<template>
  <div class="app-container">
    <div v-if="roleIsCustomer" class="welcome"></div>

    <template v-else>
      <div class="home-top cbox-p14">
        <div class="chart-title flx-justify-between">
          <div>综合统计</div>
          <el-date-picker
            v-model="searchEntustYear"
            type="year"
            placeholder="选择年"
            :clearable="false"
            value-format="yyyy"
            @change="handleYearChange()"
          ></el-date-picker>
        </div>
        <div class="top-content flx-center">
          <div class="data-box cbox-p14">
            <div class="label">业务委托总数</div>
            <div class="value">
              <svg-icon icon-class="home_entrust" />
              <div class="number">
                <CountTo :startVal="0" :endVal="topData.allCnt" />
              </div>
            </div>
          </div>
          <div class="data-box cbox-p14">
            <div class="label">流程中委托</div>
            <div class="value">
              <svg-icon icon-class="home_process" />
              <div class="number">
                <CountTo :startVal="0" :endVal="topData.processCnt" />
              </div>
            </div>
          </div>
          <div class="data-box cbox-p14">
            <div class="label">已完成委托</div>
            <div class="value">
              <svg-icon icon-class="home_success" />
              <div class="number">
                <CountTo :startVal="0" :endVal="topData.finishCnt" />
              </div>
            </div>
          </div>
          <div class="data-box cbox-p14">
            <div class="label">已完成报告</div>
            <div class="value">
              <svg-icon icon-class="home_report" />
              <div class="number">
                <CountTo :startVal="0" :endVal="topData.BgCnt" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-row :gutter="10" type="flex" style="flex-wrap: wrap; height: calc(100% - 180px)">
        <el-col :span="14" class="left-col">
          <div class="entry-wrap">
            <div class="entry-item cbox-p14" @click="handleEntry('/internalTransfer')">
              <svg-icon icon-class="home_progress" />
              <div class="name">业务进度</div>
            </div>
            <div class="entry-item cbox-p14" @click="handleEntry('/experimentCenter')">
              <svg-icon icon-class="home_waitExperiment" />
              <div class="name">编制报告</div>
            </div>
            <div class="entry-item cbox-p14" @click="handleEntry('/experimentReport')">
              <svg-icon icon-class="menu_experimentReport" />
              <div class="name">报告管理</div>
            </div>
            <div class="entry-item cbox-p14" @click="handleEntry('/expense/index')">
              <svg-icon icon-class="menu_expense" />
              <div class="name">差旅报销</div>
            </div>
          </div>
          <div class="cbox-p14">
            <div class="chart-title flx-justify-between">
              <div>业务委托趋势</div>
              <el-date-picker
                v-model="searchEntustYear"
                type="year"
                placeholder="选择年"
                :clearable="false"
                value-format="yyyy"
                @change="handleYearChange()"
              ></el-date-picker>
            </div>
            <div v-loading="entrustLoading" class="chart-box">
              <LineEntrust chartsId="LineEntrust" :data="entrustData" />
            </div>
          </div>
        </el-col>
        <el-col :span="10" class="right-col">
          <div class="cbox-p14">
            <div class="chart-title flx-justify-between">
              <div>报告进度</div>
              <el-date-picker
                v-model="searchEntustYear"
                type="year"
                placeholder="选择年"
                :clearable="false"
                value-format="yyyy"
                @change="handleYearChange()"
              ></el-date-picker>
            </div>
            <div v-loading="entrustLoading" class="chart-box">
              <PieCategory chartsId="PieCategory" :data="categoryData" />
            </div>
          </div>
          <div class="cbox-p14">
            <div class="chart-title flx-justify-between">
              <div>待办事项</div>
            </div>
            <div class="todo-list chart-box">
              <div v-for="(item, index) in todoData" :key="index" class="todo-item flx-justify-between">
                <div class="left">
                  <span v-if="item.type != 'device'">您有</span>
                  <span class="num">{{ item.num }}</span>
                  <span>{{ item.title }}</span>
                </div>
                <div class="right">
                  <el-link type="primary" @click="handleTodo(item.url)">去处理</el-link>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

import CountTo from 'vue-count-to';
import LineEntrust from './components/LineEntrust';
import PieCategory from './components/PieCategory';
import BarWork from './components/BarWork';

import { platData, trendByYear, entrustmentStateData, todoCnt, upkeepInfo } from '@/api/home';
import { getDictByCode } from '@/api/system';

export default {
  name: 'Home',
  components: { CountTo, LineEntrust, PieCategory, BarWork },
  props: {},
  data() {
    return {
      roleIsCustomer: false,
      entrustLoading: false,
      searchEntustYear: '',
      topData: {},
      entrustData: [],
      categoryLoading: false,
      searchCategoryRange: [],
      categoryData: [],
      workLoading: false,
      todoData: []
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {},
  methods: {
    handleEntry(pageUrl) {
      this.$router.push(pageUrl);
    },
    handleYearChange() {
      this.platData();
      this.trendByYear();
      this.entrustmentStateData();
    },
    async platData() {
      const { data } = await platData({ year: this.searchEntustYear });
      this.topData = data || {};
    },
    async trendByYear() {
      this.entrustLoading = true;
      try {
        const { data } = await trendByYear({ year: this.searchEntustYear });
        this.entrustData = data || [];
      } finally {
        this.entrustLoading = false;
      }
    },
    async entrustmentStateData() {
      this.categoryLoading = true;
      let categoryData = [
        {
          name: '编制中',
          cnt: 0
        },
        {
          name: '审核中',
          cnt: 0
        },
        {
          name: '批准中',
          cnt: 0
        },
        {
          name: '已完成',
          cnt: 0
        }
      ];
      try {
        const { data } = await entrustmentStateData({ year: this.searchEntustYear });
        const cntData = data || [];
        cntData.forEach(item => {
          switch (item.state) {
            case -8:
            case -9:
            case 4:
            case 6:
              categoryData[0].cnt += item['count(1)'];
              break;
            case 7:
              categoryData[1].cnt += item['count(1)'];
              break;
            case 8:
              categoryData[2].cnt += item['count(1)'];
              break;
            case 9:
              categoryData[3].cnt += item['count(1)'];
              break;
          }
        });
        this.categoryData = categoryData;
      } finally {
        this.categoryLoading = false;
      }
    },
    async getMtApplyCount() {
      const { data } = await todoCnt();
      const { data: carData } = await upkeepInfo();
      const { data: carDict } = await getDictByCode({ code: 'car_type' });
      const carMonth = carDict?.value || 6;

      let todoList = [];
      if (data && data.sbCnt > 0) {
        todoList.push({
          type: 'device',
          title: '台检测设备即将过期',
          num: data.sbCnt,
          url: '/device'
        });
      }
      if (carData && carData > 0) {
        todoList.push({
          type: 'device',
          title: `台车辆已超过保养期限${carMonth}个月`,
          num: carData,
          url: '/car'
        });
      }
      if (data && data.bzCnt > 0) {
        todoList.push({
          type: 'report',
          title: '份检测报告待编制',
          num: data.bzCnt,
          url: '/experimentCenter'
        });
      }
      if (data && data.thCnt > 0) {
        todoList.push({
          type: 'report',
          title: '份检测报告被退回，需要修正',
          num: data.thCnt,
          url: '/experimentCenter'
        });
      }
      if (data && data.shCnt > 0) {
        todoList.push({
          type: 'report',
          title: '份检测报告待审核',
          num: data.shCnt,
          url: '/audit/reportAudit'
        });
      }
      if (data && data.pzCnt > 0) {
        todoList.push({
          type: 'report',
          title: '份检测报告待批准',
          num: data.pzCnt,
          url: '/audit/reportApprove'
        });
      }
      if (data && data.dbCnt > 0) {
        todoList.push({
          type: 'report',
          title: '份委托信息待分配',
          num: data.dbCnt,
          url: '/taskAllocation'
        });
      }
      this.todoData = todoList;
    },
    handleTodo(pageUrl) {
      this.$router.push(pageUrl);
    }
  },
  created() {
    const nowYear = moment().format('YYYY');
    this.searchEntustYear = nowYear;
  },
  mounted() {},
  activated() {
    this.platData();
    this.trendByYear();
    this.entrustmentStateData();
    this.getMtApplyCount();
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
.welcome {
  width: 100%;
  height: 100%;
  background: #ffffff url(~@/assets/images/bg-welcome.png) no-repeat center center/contain;
}

.home-top {
  height: 170px;
  margin-bottom: 10px;

  .top-content {
    width: 100%;
    gap: 20px;
  }
  .data-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100px;
    color: #ffffff;
    border-radius: 14px;

    &:nth-of-type(1) {
      background-color: #217e52;
    }
    &:nth-of-type(2) {
      background-color: #af5353;
    }
    &:nth-of-type(3) {
      background-color: #806d42;
    }
    &:nth-of-type(4) {
      background-color: #9d539e;
    }
    .label {
      font-size: 18px;
      font-weight: 700;
    }
    .value {
      display: flex;
      align-items: center;
      margin-top: 10px;

      .svg-icon {
        font-size: 40px;
      }
      .number {
        font-size: 32px;
        margin-left: 20px;
      }
    }
  }
}

.entry-wrap {
  width: calc(100% - 30px);
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;

  .entry-item {
    display: flex;
    align-items: center;
    flex: 0 0 25%;
    height: 58px;
    background-color: #ffffff;
    color: #333333;
    cursor: pointer;

    .svg-icon {
      font-size: 30px;
      margin-right: 14px;
    }
  }
}

.el-row {
  height: 100%;

  .el-col {
    height: 100%;
  }
}

.left-col {
  display: flex;
  flex-direction: column;

  > .cbox-p14 {
    flex: 1;
  }
}

.right-col {
  display: flex;
  flex-direction: column;

  > div {
    flex: 1;

    & + div {
      margin-top: 10px;
    }
  }
}

.chart-title {
  min-height: 42px;
  width: 100%;
  font-weight: 700;
}

.chart-box {
  width: 100%;
  height: calc(100% - 42px);
}

.todo-list {
  width: 100%;
  overflow: hidden;
  overflow-y: auto;

  .todo-item {
    font-size: 16px;
    color: #333;
    padding: 10px;
    border-bottom: 1px solid #f1f5f9;

    &:last-of-type {
      border-bottom: none;
    }
    .num {
      color: #1890ff; // 用品牌色突出数字
      font-weight: bold;
    }

    .right .el-link {
      font-size: 14px;
    }
  }
}
</style>
